module.exports = __webpack_public_path__ + "img/cause_2.283e51b8.svg";